module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/profile-a0b1cff69193fdf81c38b83130fd4089.png";